/*LIBRARY*/
import { connect, useDispatch } from "react-redux";

/*COMPONENT*/
import PARENT_SINI from "../sini_v2/PARENT_SINI";
import SITE_SELECTION from "../site_selection/SITE_SELECTION";
import BLOCKED from "../sini_data/BLOCKED";

/*REDUX*/
import { set_value_sini_data } from "../../App/actions/sini_data_actions";
import { set_value_properties } from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/
import { is_user_get_access_by_license_key } from "../../App/actions/filter_license";

/*DATA*/

/*CONST*/

const SINI_WRAPER = ({ set_value_properties, properties }) => {
  const menuList = ["Site Selection", "Site Analysis"];
  const dispatch = useDispatch();

  const on_set_menu = (dt) => {
    set_value_properties({
      key: "sini_data_mode",
      value: dt,
    });
  };

  const { sini_data_mode } = properties;

  //local storage

  //local state

  //global props
  const content =
    sini_data_mode === "Site Analysis" ? <PARENT_SINI /> : <SITE_SELECTION />;

  const is_has_access_sini = dispatch(
    is_user_get_access_by_license_key("license_sini_data"),
  );

  return (
    <main>
      <div className="menu_container_basic background_grey_light two_container_equal margin_bottom">
        {menuList.map((dt, idx) => (
          <button
            key={idx}
            className={`button_small full_width ${
              sini_data_mode === dt
                ? "background_black"
                : "background_grey_light"
            }`}
            onClick={() => on_set_menu(dt)}
            data-mapid={
              dt === "Site Analysis" ? "siteAnalysis" : "siteSelection"
            }
          >
            {dt}
          </button>
        ))}
      </div>

      {is_has_access_sini?.is_pass ? (
        content
      ) : (
        <div
          style={{
            minHeight: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <BLOCKED {...is_has_access_sini} />
        </div>
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  project: state.project,
  properties: state.properties,
  loading_reducer: state.loading_reducer,
  sini_data_reducer: state.sini_data_reducer,
});

export default connect(mapStateToProps, {
  set_value_sini_data,
  is_user_get_access_by_license_key,
  set_value_properties,
})(SINI_WRAPER);
